import React from 'react'
import gql from 'graphql-tag'
import Query from 'react-apollo/Query'
import { EmailDomainsQueryArgs } from '../../graphql/schema/queries/email-domains'

export const emailDomainsQuery = gql`
  query emailDomains($organizationID: ID!) {
    emailDomains(organizationID: $organizationID) {
      organizationID
      domains
    }
  }
`

export function EmailDomainsQuery({
  organizationID,
  children
}: {
  readonly organizationID: string
  readonly children: (props: { readonly domains?: string[] }) => React.ReactNode
}) {
  return (
    <Query<
      { readonly emailDomains: { readonly domains: string } },
      EmailDomainsQueryArgs
    >
      query={emailDomainsQuery}
      variables={{ organizationID }}
      fetchPolicy="network-only"
    >
      {({ data, error, loading }) => {
        if (error) {
          console.error(error)
          throw new Error('Error caught when requesting email domains')
        }
        if (error || loading || !data) {
          return <div />
        }

        const {
          emailDomains: { domains }
        } = data

        return children({
          domains: domains ? domains.replace(/ /g, '').split(',') : undefined
        })
      }}
    </Query>
  )
}
